import React from 'react';
import { GatsbyImage, getImage } from 'gatsby-plugin-image';
import Chevron from 'assets/icons/chevron-right.svg';
import { SmartLink } from 'components/smart-link';
import { LinkType, MenuItemType, SectionItemType } from 'components/header/types';
import { classnames } from 'helpers/utils';
import * as styles from './menuItem.module.scss';

type MenuItemProps = {
  menuItem: MenuItemType;
};

export const MenuItem = ({ menuItem }: MenuItemProps) => (
  <div className={classnames(styles.menuItem)}>
    <div className={styles.sectionsContainer}>
      {menuItem.sections.map((s: SectionItemType) => {
        const image = getImage(s.callToAction?.image?.localFile);

        return (
          <div key={s.id}>
            <div className={styles.sectionTitle}>
              <div>
                {s.title}
              </div>
              {s.viewAllLink && (
              <SmartLink to={s.viewAllLink} className={styles.viewAllLink}>
                View all
                <Chevron />
              </SmartLink>
              )}
            </div>
            <div className={styles.titleDivider} />
            <div className={styles.linksContainer}>
              {s.links.map((l: LinkType) => (
                <SmartLink key={l.id} to={l.link} className={styles.link}>{l.name}</SmartLink>
              ))}
            </div>
            {s.callToAction && (
              <div className={styles.callToActionContent}>
                {image
                && (
                  <GatsbyImage
                    image={image}
                    alt={s.title}
                    className={styles.callToActionImage}
                  />
                )}
                {s.callToAction.button
                && (
                  <SmartLink
                    className={styles.callToActionButton}
                    to={s.callToAction.button.link}
                  >
                    {s.callToAction.button.name}
                  </SmartLink>
                )}
              </div>
            )}
          </div>
        );
      })}
    </div>
  </div>
);
